export const usePublicationsStore = defineStore('publications', () => {
  const publications = ref([])

  const setPublications = (getPublications) => {
    publications.value = getPublications
  }

  const getPublications = computed(() => {
    let result = [...publications.value]

    return result.sort(
      (a, b) =>
        Date.parse(b.publicationDate.released) -
        Date.parse(a.publicationDate.released)
    )
  })

  return {
    publications,
    setPublications,
    getPublications,
  }
})
